import React, { useState, useEffect } from "react";
import ExcelFileUpload from "./excelFileUpload";
import ReactLoading from "react-loading";
import * as XLSX from "xlsx";
import { getAuth } from "firebase/auth";
import {
  doc,
  getDoc,
  setDoc,
  collection,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { firestore } from "../../../firebase";
import { TiDelete } from "react-icons/ti";
import { useLanguage } from "../../../LanguageContext";
import * as text from "../../../translation.json";

import NewMenuTextDemo from "./components/newMenuTextDemo";

const auth = getAuth();
const db = firestore;

const EditMenu = ({
  locationId,
  newMenu,
  setNewMenu,
  lokasjonstype,
  menuList,
  setMenuList,
  editLanguage,
  newMenuEnglish,
  setNewMenuEnglish,
  menuListEnglish,
  setMenuListEnglish,
  textInformation,
  setTextInformation,
  menuFetchSelectors,
  setMenuFetchSelectors,
  menuFetchUrl,
  setMenuFetchUrl,
  menuFetchAvailable,
  setMenuFetchAvailable,
  menuFetchUrlEnglish,
  setMenuFetchUrlEnglish,
  config,
  setConfig,
  menuFetchUrlType,
  setMenuFetchUrlType,
  ignoreTerms,
  setIgnoreTerms,
  includeTerms,
  setIncludeTerms,
  suggestedTags, 
  setSuggestedTags
}) => {
  const { language } = useLanguage();
  const [selectedCategory, setSelectedCategory] = useState("");
  const [visibleMenus, setVisibleMenus] = useState({});
  const [newMenuFields, setNewMenuFields] = useState({
    name: "",
    allergies: "",
    price: "",
    description: "",
    newCategory: "",
  });
  const [missingFields, setMissingFields] = useState({
    name: false,
    allergies: false,
    price: false,
    description: false,
    category: false,
    newCategory: false,
  });
  const [excelJsonData, setExelJsonData] = useState(null);
  const [isEditable, setIsEditable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [newMenuType, setNewMenuType] = useState("");
  const [userInformation, setUserInfomation] = useState(null);
  const [loadingGetTags, setLoadingGetTags] = useState(false);



  const currency = textInformation.currency ? textInformation.currency : "NOK";

  const toggleEditMode = () => {
    setIsEditable(!isEditable);
  };

  useEffect(() => {
    auth.onAuthStateChanged(async function (user) {
      if (user) {
        const userDoc = doc(db, "users", user.uid);

        const userInfo = await getDoc(userDoc);
        setUserInfomation(userInfo.data());

    if(userInfo.data()?.admin) {
      setNewMenuType("demo1");
      setNewMenu(true);
    }
      }
    });
  }, [auth]);

  // Set initial visibility
  useEffect(() => {
    const menuVisibility = {};
    Object.keys(menuList).forEach((element) => {
      menuVisibility[element] = false; // Start with all menus expanded
    });

    setVisibleMenus(menuVisibility);
  }, [menuList]);

  const toggleMenuVisibility = (element) => {
    setVisibleMenus((prevVisibleMenus) => ({
      ...prevVisibleMenus,
      [element]: !prevVisibleMenus[element],
    }));
  };

  const addNewMenuItem = () => {
    // Clone the menuList to avoid mutating the original object directly.
    let updatedMenuItems = [...menuList];

    let isAnyFieldMissing = false;

    let updatedMissingFields = {
      name: false,
      allergies: false,
      price: false,
      description: false,
      category: false,
      newCategory: selectedCategory === "newCategory" ? false : true,
    };

    // Check each field except 'newCategory'
    Object.keys(newMenuFields).forEach((key) => {
      if (key !== "newCategory" && newMenuFields[key].trim() === "") {
        updatedMissingFields[key] = true;
        isAnyFieldMissing = true;
      }
    });

    // Check 'newCategory' only if selectedCategory is 'newCategory'
    if (selectedCategory === "") {
      updatedMissingFields.category = true;
      isAnyFieldMissing = true;
    }
    if (
      selectedCategory === "newCategory" &&
      newMenuFields.newCategory.trim() === ""
    ) {
      updatedMissingFields.newCategory = true;
      isAnyFieldMissing = true;
    }

    // Update the missingFields state
    setMissingFields(updatedMissingFields);

    // If any field is missing, return early
    if (isAnyFieldMissing) {
      return;
    } else {
      if (selectedCategory === "newCategory") {
        // Find the category or create a new one
        let categoryIndex = updatedMenuItems.findIndex(
          (item) => item.category === newMenuFields.newCategory,
        );

        if (categoryIndex === -1) {
          updatedMenuItems.push({
            category: newMenuFields.newCategory,
            menuItems: [],
            allergies: [],
            prices: [],
            descriptions: [],
          });
          categoryIndex = updatedMenuItems.length - 1;
        }

        // Now that you've ensured the category and its arrays exist, you can safely push the new values
        updatedMenuItems[categoryIndex].menuItems.push(newMenuFields.name);
        updatedMenuItems[categoryIndex].allergies.push(newMenuFields.allergies);
        updatedMenuItems[categoryIndex].prices.push(
          parseFloat(newMenuFields.price),
        );
        updatedMenuItems[categoryIndex].descriptions.push(
          newMenuFields.description,
        );

        // Continue with updating the state or any other logic you need...
        console.log(updatedMenuItems);
        setMenuList(updatedMenuItems);

        // Now, updatedMenuItems reflects the updated structure.
      } else {
        // Find the category index
        let categoryIndex = updatedMenuItems.findIndex(
          (item) => item.category === selectedCategory,
        );

        if (categoryIndex !== -1) {
          // Directly access and update the necessary arrays.
          updatedMenuItems[categoryIndex].menuItems.push(newMenuFields.name);
          updatedMenuItems[categoryIndex].allergies.push(
            newMenuFields.allergies,
          );
          updatedMenuItems[categoryIndex].prices.push(
            parseFloat(newMenuFields.price),
          );
          updatedMenuItems[categoryIndex].descriptions.push(
            newMenuFields.description,
          );

          // Now, updatedMenuItems reflects the updated structure.
          console.log(updatedMenuItems);
          setMenuList(updatedMenuItems);
        }
      }
      onGoBack();
    }

    // If you need to update the state or propagate these changes, do so here.
    // For example, if menuList is a state variable, you should call setState or equivalent here.
  };

  const onGoBack = () => {
    setNewMenu(false);
    setNewMenuFields({
      name: "",
      allergies: "",
      price: "",
      description: "",
      newCategory: "",
    });
    setMissingFields({
      name: false,
      allergies: false,
      price: false,
      description: false,
      category: false,
      newCategory: false,
    });
    setSelectedCategory("");
  };

  //ny kode:
  const handleMenuFileUploaded = (headers, data) => {
    const requiredHeaders = [
      "Kategori (hvilken kategori tilhører objektet?)",
      "Navn på menyobjekt",
      "Pris (kun siffer)",
      "Allergener (skilles med komma)",
      "Beskrivelse av objektet",
    ];

    const headersMatch =
      requiredHeaders.length === headers.length &&
      requiredHeaders.every(
        (header, index) => header.trim() === headers[index].trim(),
      );

    if (!headersMatch) {
      alert(
        "Filen du lastet opp bruker feile headere. Pass på å kun benytte deg av følgende headere: " +
          requiredHeaders.join(", "),
      );
      return;
    }

    const processedData = data.reduce((acc, row) => {
      const category = row[0].trim();
      let categoryIndex = acc.findIndex((item) => item.category === category);

      if (categoryIndex === -1) {
        acc.push({
          category: category,
          alergener: [],
          descriptions: [],
          menuItems: [],
          prices: [],
        });
        categoryIndex = acc.length - 1;
      }

      acc[categoryIndex].menuItems.push(row[1] !== undefined ? row[1] : "");
      acc[categoryIndex].prices.push(
        row[2] !== undefined ? parseFloat(row[2]) : 0,
      );
      acc[categoryIndex].alergener.push(row[3] !== undefined ? row[3] : "");
      acc[categoryIndex].descriptions.push(row[4] !== undefined ? row[4] : "");

      return acc;
    }, []);

    setMenuList(processedData);
  };

  //ny kode:

  const downloadExcel = () => {
    if (!menuList) return;

    const headers = [
      "Kategori (hvilken kategori tilhører objektet?)",
      "Navn på menyobjekt",
      "Pris (kun siffer)",
      "Allergener (skilles med komma)",
      "Beskrivelse av objektet",
    ];

    const data = [];

    menuList.forEach((categoryData) => {
      const { category, menuItems, prices, alergener, descriptions } =
        categoryData;

      // Assuming that all arrays (menuItems, prices, alergener, descriptions) have the same length
      for (let i = 0; i < menuItems.length; i++) {
        const row = [
          category,
          menuItems[i],
          prices[i],
          alergener[i],
          descriptions[i],
        ];
        data.push(row);
      }
    });

    console.log(data);
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);

    // Set column widths
    worksheet["!cols"] = [
      { wpx: 200 }, // "Kategori (hvilken kategori tilhører objektet?)"
      { wpx: 200 }, // "Navn på menyobjekt"
      { wpx: 100 }, // "Pris"
      { wpx: 200 }, // "Allergener (skilles med komma)"
      { wpx: 300 }, // "Beskrivelse av objektet"
    ];

    // Add header styling
    headers.forEach((header, index) => {
      const cell = XLSX.utils.encode_cell({ r: 0, c: index });
      if (!worksheet[cell]) worksheet[cell] = {};
      worksheet[cell].s = {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
        fill: {
          fgColor: { rgb: "FFFFAA00" }, // Light orange fill
        },
      };
    });

    // Add border styling to all cells
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
        if (cell) {
          if (!cell.s) cell.s = {};
          cell.s.border = {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          };
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "MapliMenuItems.xlsx");
  };

  // const translateText = async (text) => {
  //   try {
  //     const response = await fetch(
  //       `https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/translateText/en/${text}`
  //     );
  //     const result = await response.json();
  //     console.log(
  //       `Translated "${text}" to "${result.choices[0].message.content}"`
  //     ); // Debugging line
  //     return result.choices[0].message.content; // Adjust based on your API's response structure
  //   } catch (error) {
  //     console.error(`Error translating text "${text}":`, error);
  //     return text; // Fallback to the original text in case of an error
  //   }
  // };

  const TARGET_LANG = "en-US";

  const translateText = async (text) => {
    try {
      const res = await fetch(
        "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/translateWithDeepL",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            text,
            toLang: TARGET_LANG,
            fromLang: textInformation.lang,
          }),
        },
      );

      const json = await res.json();
      return json.text ?? text;
    } catch (err) {
      console.error("Translate error:", err);
      return text;
    }
  };

const translateBatch = async (texts) => {
  try {
    const res = await fetch(
      "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/translateWithDeepL",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          texts,
          toLang: TARGET_LANG,
          fromLang: textInformation.lang,
        }),
      },
    );

    const json = await res.json();
    const result = json.text ?? texts;

    if (!Array.isArray(result) || result.length !== texts.length) {
      console.error("translateBatch length mismatch", {
        sent: texts.length,
        received: Array.isArray(result) ? result.length : typeof result,
      });
      return texts; // fail safe — keep original rather than risk undefined drift
    }

    return result;
  } catch (err) {
    console.error("Batch translate error:", err);
    return texts;
  }
};

  const translateObject = async (data) => {
    const translatedData = {};

    for (const key in data) {
      if (Array.isArray(data[key])) {
        translatedData[key] = await Promise.all(
          data[key].map(async (item) => {
            if (typeof item === "string") {
              return await translateText(item);
            } else if (typeof item === "object" && item !== null) {
              return await translateObject(item);
            }
            return item;
          }),
        );
      } else if (typeof data[key] === "object" && data[key] !== null) {
        translatedData[key] = await translateObject(data[key]);
      } else if (typeof data[key] === "string") {
        translatedData[key] = await translateText(data[key]);
      } else {
        translatedData[key] = data[key];
      }
    }

    return translatedData;
  };

  const handleTranslate = async () => {
  setIsLoading(true);

  const categories = menuList.map((c) => c.category);
  const items = menuList.flatMap((c) => c.menuItems);
  const alergener = menuList.flatMap((c) => c.alergener);
  const descriptions = menuList.flatMap((c) => c.descriptions);

  // ✅ NEW: collect overcategory, defaulting missing ones to "" so the array
  // stays aligned with menuList by index. We track which ones actually existed
  // so we can restore null/undefined afterwards instead of leaving "".
  const overcategories = menuList.map((c) => c.overcategory ?? "");
  const hasOvercategory = menuList.map(
    (c) => c.overcategory !== null && c.overcategory !== undefined && c.overcategory !== ""
  );

  const [
    translatedCategories,
    translatedItems,
    translatedAlergener,
    translatedDescriptions,
    translatedOvercategories, // ✅ NEW
  ] = await Promise.all([
    translateBatch(categories),
    translateBatch(items),
    translateBatch(alergener),
    translateBatch(descriptions),
    translateBatch(overcategories), // ✅ NEW
  ]);

  let itemIndex = 0;
  let descIndex = 0;
  let algIndex = 0;

  const translatedData = menuList.map((c, i) => {
    const result = {
      category: translatedCategories[i],
      // ✅ NEW: only assign a translated overcategory if it existed originally,
      // otherwise preserve the original (null/undefined/"")
      overcategory: hasOvercategory[i]
        ? translatedOvercategories[i]
        : c.overcategory,
      menuItems: c.menuItems.map(() => translatedItems[itemIndex++]),
      alergener: c.alergener.map(() => translatedAlergener[algIndex++]),
      descriptions: c.descriptions.map(
        () => translatedDescriptions[descIndex++],
      ),
      prices: c.prices,
      variants: c.variants,
    };
    return result;
  });

  if (textInformation.allergiesSubstitutes) {
    const [translated] = await translateBatch([
      textInformation.allergiesSubstitutes,
    ]);
    setTextInformation((prev) => ({
      ...prev,
      allergiesSubstitutes_enUS: translated,
    }));
  }

const sanitize = (obj) => JSON.parse(JSON.stringify(obj));
setMenuListEnglish(sanitize(translatedData));
  setIsLoading(false);
};

  const addNewItemToCategory = (categoryData) => {
    let updatedMenuItems = [...menuList];
    let categoryIndex = updatedMenuItems.findIndex(
      (item) => item.category === categoryData.category,
    );

    if (categoryIndex !== -1) {
      updatedMenuItems[categoryIndex].menuItems.push("Ny rett");
      updatedMenuItems[categoryIndex].alergener.push("");
      updatedMenuItems[categoryIndex].prices.push(0);
      updatedMenuItems[categoryIndex].descriptions.push("");
      setMenuList(updatedMenuItems);
      setIsEditable(true);
    }
  };

  const onDeleteSelectedItem = (itemIndex, categoryData) => {
    console.log(
      "Deleting item at index:",
      itemIndex,
      "from category:",
      categoryData,
    );
    let updatedMenuItems = [...menuList];
    let categoryIndex = updatedMenuItems.findIndex(
      (item) => item.category === categoryData.category,
    );
    if (categoryIndex !== -1) {
      updatedMenuItems[categoryIndex].menuItems.splice(itemIndex, 1);
      updatedMenuItems[categoryIndex].alergener.splice(itemIndex, 1);
      updatedMenuItems[categoryIndex].prices.splice(itemIndex, 1);
      updatedMenuItems[categoryIndex].descriptions.splice(itemIndex, 1);
      setMenuList(updatedMenuItems);
    }
  };

  const onGetSuggestedTags = async () => {
    setLoadingGetTags(true);
    console.log("Fetching suggested tags");
      try {
              const response = await fetch(
        "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/tags/generate",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            restaurantId: locationId,
            // Send the in-progress menu directly so tags can be generated
            // before saving — the backend falls back to the last-saved
            // Firestore menus only when this is omitted.
            menus: menuList,
          }),
        },
      );
        const result = await response.json();
        console.log("Suggested tags:", result);
        console.log("Generated tags:", textInformation.lang);
        setSuggestedTags(result.generatedTags || []);
      } catch (error) {
        console.error("Error fetching suggested tags:", error);
      }
    setLoadingGetTags(false);
  };

  // Old tags mentioning these are kept even though we otherwise replace the
  // whole tag list — they describe what the place IS rather than what's on
  // the menu, so the generator has no way to reconstruct them on its own.
  const VENUE_TYPE_KEYWORDS = ["pub", "bar", "cafe", "gastropub", "sportsbar"];

  // tags.json only has en_US, nb_NO, es_ES and sv_SE — fall back to English
  // for other languages (e.g. nl_NL in Amsterdam) instead of crashing.
  const suggestedTagsForLang =
    suggestedTags?.[textInformation.lang] || suggestedTags?.en_US || [];

  const onAddSuggestedTags = () => {
    const oldTags = textInformation.tags || [];
    const generatedTags = suggestedTagsForLang;
    const mainTags = textInformation.locationTags || [];

    const preservedVenueTags = oldTags.filter((t) =>
      VENUE_TYPE_KEYWORDS.some((kw) => String(t).toLowerCase().includes(kw)),
    );

    // Replace rather than merge with the old list — combine what the
    // generator found with the main tags and the preserved venue-type tags.
    const combinedTags = Array.from(
      new Set([...generatedTags, ...mainTags, ...preservedVenueTags]),
    );

    setTextInformation({
      ...textInformation,
      tags: combinedTags,
    });
  };

  // Shown both above the menu list below and inside NewMenuTextDemo (passed
  // as a prop), so tags can be generated right after scraping a menu without
  // leaving the demo. Same state either way.
  const suggestedTagsPanel = userInformation?.admin ? (
    <>
      <button onClick={onGetSuggestedTags}>Get suggested tags</button>
      {loadingGetTags && (
        <ReactLoading type={"spin"} color={"#357EDD"} height={60} width={30} />
      )}
      {suggestedTagsForLang.length > 0 && (
        <>
          <div>
            <h4>Suggested Tags:</h4>
            <ul>
              {suggestedTagsForLang.map((tag, index) => (
                <li key={index}>{tag}</li>
              ))}
            </ul>
          </div>
          <button onClick={() => onAddSuggestedTags()}>Add all tags</button>
        </>
      )}
    </>
  ) : null;

  return (
    <>
      <div className='menuPageContainer'>
        {userInformation?.studentOrganisasjon ? (
          <label>På denne siden i appen vil arrangementene deres vises!</label>
        ) : !newMenu ? (
          <>
            <label className='editPageLabel'>
              {lokasjonstype === "restaurant"
                ? text[language].menylister
                : text[language].Activities} {userInformation?.admin && " - " + menuFetchUrlType + " - " + menuFetchUrl}
              {editLanguage === "english" ? (
                <>
                  {" "}
                  <a
                    href='#'
                    class='editPageLink'
                    onClick={() => (setIsLoading(true), handleTranslate())}>
                    {text[language].translateautomatically}
                  </a>
                  {isLoading ? (
                    <ReactLoading
                      type={"spin"}
                      color={"#357EDD"}
                      height={60}
                      width={30}
                    />
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}
            </label>
            <label>
              {textInformation.menusChanged ? (
                <div
                  style={{
                    color: "gray",
                    fontWeight: "normal",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    setTextInformation({
                      ...textInformation,
                      menusChanged: new Date().getTime(),
                    })
                  }>
                  {text[language].sistoppdatert}{" "}
                  {new Date(textInformation.menusChanged).toLocaleDateString() +
                    " " +
                    new Date(
                      textInformation.menusChanged,
                    ).toLocaleTimeString() +
                    " "}{" "}
                  - {text[language].oppdater}
                </div>
              ) : (
                <div
                  style={{
                    color: "gray",
                    fontWeight: "normal",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    setTextInformation({
                      ...textInformation,
                      menusChanged: new Date().getTime(),
                    })
                  }>
                  - {text[language].oppdater}
                </div>
              )}
            </label>

            <label className='editPageLabel'>
              {text[language].extraalergeninfo}
            </label>
            <textarea
              placeholder={text[language].extraalergeninfodescription}
              value={
                editLanguage !== "english"
                  ? textInformation.allergiesSubstitutes
                  : textInformation.allergiesSubstitutes_enUS
              }
              onChange={(e) => {
                if (editLanguage !== "english") {
                  setTextInformation((prev) => ({
                    ...prev,
                    allergiesSubstitutes: e.target.value,
                  }));
                } else {
                  setTextInformation((prev) => ({
                    ...prev,
                    allergiesSubstitutes_enUS: e.target.value,
                  }));
                }
              }}
            />
            <br />
            {editLanguage === "english" && userInformation?.admin && (
              <a
                href='#'
                class='editPageLink'
                onClick={() => setMenuListEnglish(menuList)}>
                {text[language].copyEverythingFromOriginalLanguage}
              </a>
            )}
            {suggestedTagsPanel}
            {editLanguage !== "english" ? (
              menuList.length > 0 ? (
                menuList.map((categoryData, index) => (
                  <div key={index} className='menuListDropdown'>
                    <h3
                      onClick={() =>
                        toggleMenuVisibility(categoryData.category)
                      }>
                      {categoryData.category} ⯆
                    </h3>
                    {visibleMenus[categoryData.category] && (
                      <div className='menuListShown'>
                        {categoryData.menuItems.map((itemName, itemIndex) => (
                          <div key={itemIndex} className='menuListShownItem'>
                            <div style={{ fontWeight: "bold" }}>
                              {isEditable ? (
                                <input
                                  type='text'
                                  defaultValue={itemName}
                                  onChange={(e) => {
                                    // handle name change
                                    const newMenuItems = [
                                      ...categoryData.menuItems,
                                    ];
                                    newMenuItems[itemIndex] = e.target.value;
                                    categoryData.menuItems = newMenuItems; // Update your state management accordingly
                                  }}
                                />
                              ) : (
                                itemName.charAt(0).toUpperCase() +
                                itemName.slice(1)
                              )}
                              <TiDelete
                                size={23}
                                style={{
                                  cursor: "pointer",
                                  color: "red",
                                }}
                                onClick={() => {
                                  onDeleteSelectedItem(itemIndex, categoryData);
                                }}
                              />
                            </div>
                            <div style={{ color: "#5d3160" }}>
                              {isEditable ? (
                                <input
                                  type='number'
                                  defaultValue={categoryData.prices[itemIndex]}
                                  onChange={(e) => {
                                    // Parse the value as a float (or int if you prefer)
                                    const value = parseFloat(e.target.value);

                                    // Only update if the value is a valid number
                                    if (!isNaN(value)) {
                                      const newPrices = [
                                        ...categoryData.prices,
                                      ];
                                      newPrices[itemIndex] = value; // Save the numeric value
                                      categoryData.prices = newPrices; // Update your state management accordingly
                                    }
                                  }}
                                />
                              ) : categoryData.prices[itemIndex] !== null &&
                                categoryData.prices[itemIndex] !== undefined ? (
                                `${categoryData.prices[itemIndex]} ${currency}`
                              ) : Array.isArray(
                                  categoryData.variants?.[itemIndex],
                                ) &&
                                categoryData.variants?.[itemIndex]?.length >
                                  0 ? (
                                categoryData.variants[itemIndex]
                                  .map(
                                    (v) => `${v.name} ${v.price} ${currency}`,
                                  )
                                  .join(" | ")
                              ) : (
                                "Ingen pris oppgitt"
                              )}
                            </div>
                            <div style={{ marginTop: "5px" }}>
                              {isEditable ? (
                                <textarea
                                  defaultValue={
                                    categoryData.descriptions[itemIndex]
                                  }
                                  onChange={(e) => {
                                    // handle description change
                                    const newDescriptions = [
                                      ...categoryData.descriptions,
                                    ];
                                    newDescriptions[itemIndex] = e.target.value;
                                    categoryData.descriptions = newDescriptions; // Update your state management accordingly
                                  }}
                                />
                              ) : (
                                categoryData.descriptions[itemIndex]
                                  .charAt(0)
                                  .toUpperCase() +
                                categoryData.descriptions[itemIndex].slice(1)
                              )}
                            </div>
                            <div style={{ marginTop: "5px" }}>
                              Allergener:
                              {isEditable ? (
                                <input
                                  type='text'
                                  defaultValue={
                                    categoryData.alergener[itemIndex]
                                  }
                                  onChange={(e) => {
                                    // handle name change
                                    const newDescriptions = [
                                      ...categoryData.alergener,
                                    ];
                                    newDescriptions[itemIndex] = e.target.value;
                                    categoryData.alergener = newDescriptions; // Update your state management accordingly
                                  }}
                                />
                              ) : (
                                categoryData.alergener[itemIndex]
                                  .charAt(0)
                                  .toUpperCase() +
                                categoryData.alergener[itemIndex].slice(1)
                              )}
                            </div>
                          </div>
                        ))}
                        <button onClick={toggleEditMode}>
                          {isEditable ? "Lagre" : "Rediger"}
                        </button>{" "}
                        {!isEditable && (
                          <button
                            onClick={() => addNewItemToCategory(categoryData)}>
                            {text[language].addnewmeny}
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <></>
              )
            ) : (
              <>
                {menuListEnglish.length > 0 ? (
                  menuListEnglish.map((categoryData, index) => (
                    <div key={index} className='menuListDropdown'>
                      <h3
                        onClick={() =>
                          toggleMenuVisibility(categoryData.category)
                        }>
                        {categoryData.category} ⯆
                      </h3>
                      {visibleMenus[categoryData.category] && (
                        <div className='menuListShown'>
                          {categoryData.menuItems.map((itemName, itemIndex) => (
                            <div key={itemIndex} className='menuListShownItem'>
                              <div style={{ fontWeight: "bold" }}>
                                {isEditable ? (
                                  <input
                                    type='text'
                                    defaultValue={itemName}
                                    onChange={(e) => {
                                      const newMenuItems = [
                                        ...categoryData.menuItems,
                                      ];
                                      newMenuItems[itemIndex] = e.target.value;
                                      categoryData.menuItems = newMenuItems; // Update your state management accordingly
                                    }}
                                  />
                                ) : (
                                  itemName.charAt(0).toUpperCase() +
                                  itemName.slice(1)
                                )}
                              </div>
                              <div style={{ color: "#5d3160" }}>
                                {isEditable ? (
                                  <input
                                    type='number'
                                    defaultValue={
                                      categoryData.prices[itemIndex]
                                    }
                                    onChange={(e) => {
                                      const value = parseFloat(e.target.value);
                                      if (!isNaN(value)) {
                                        const newPrices = [
                                          ...categoryData.prices,
                                        ];
                                        newPrices[itemIndex] = value; // Save the numeric value
                                        categoryData.prices = newPrices; // Update your state management accordingly
                                      }
                                    }}
                                  />
                                ) : categoryData.prices[itemIndex] !== null &&
                                  categoryData.prices[itemIndex] !==
                                    undefined ? (
                                  `${categoryData.prices[itemIndex]} ${currency}`
                                ) : Array.isArray(
                                    categoryData.variants?.[itemIndex],
                                  ) &&
                                  categoryData.variants?.[itemIndex]?.length >
                                    0 ? (
                                  categoryData.variants[itemIndex]
                                    .map(
                                      (v) => `${v.name} ${v.price} ${currency}`,
                                    )
                                    .join(" | ")
                                ) : (
                                  "Ingen pris oppgitt"
                                )}
                              </div>
                              <div style={{ marginTop: "5px" }}>
                                {isEditable ? (
                                  <textarea
                                    defaultValue={
                                      categoryData.descriptions[itemIndex]
                                    }
                                    onChange={(e) => {
                                      const newDescriptions = [
                                        ...categoryData.descriptions,
                                      ];
                                      newDescriptions[itemIndex] =
                                        e.target.value;
                                      categoryData.descriptions =
                                        newDescriptions; // Update your state management accordingly
                                    }}
                                  />
                                ) : (
                                  categoryData.descriptions[itemIndex]
                                    .charAt(0)
                                    .toUpperCase() +
                                  categoryData.descriptions[itemIndex].slice(1)
                                )}
                              </div>
                              <div style={{ marginTop: "5px" }}>
                                Allergener:{" "}
                                {isEditable ? (
                                  <input
                                    type='text'
                                    defaultValue={
                                      categoryData.alergener[itemIndex]
                                    }
                                    onChange={(e) => {
                                      const newAlergeners = [
                                        ...categoryData.alergener,
                                      ];
                                      newAlergeners[itemIndex] = e.target.value;
                                      categoryData.alergener = newAlergeners; // Update your state management accordingly
                                    }}
                                  />
                                ) : (
                                  categoryData.alergener[itemIndex]
                                    .charAt(0)
                                    .toUpperCase() +
                                  categoryData.alergener[itemIndex].slice(1)
                                )}
                              </div>
                            </div>
                          ))}
                          <button onClick={toggleEditMode}>
                            {isEditable ? "Lagre" : "Rediger"}
                          </button>
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <></>
                )}
              </>
            )}

            {editLanguage !== "english" ? (
              <>
                <a
                  href='#'
                  onClick={() => {
                    setNewMenu(true);
                  }}
                  className='editPageLink'
                  style={{ marginTop: "15px" }}>
                  {text[language].addnewmeny} +
                </a>
                <div className='editPageMenuExcelContainer'>
                  <button
                    onClick={downloadExcel}
                    className='editPageExcelDownloadButton'>
                    Klikk for å laste ned menyobjektene i en excelfil for
                    enklere å laste opp flere menyobjekter på samme tid
                  </button>
                  <ExcelFileUpload onFileUploaded={handleMenuFileUploaded} />
                </div>
              </>
            ) : (
              <></>
            )}
          </>
        ) : newMenuType === "demo1" ? (
          <NewMenuTextDemo
            setNewMenuType={setNewMenuType}
            newMenu={newMenu}
            setNewMenu={setNewMenu}
            menuList={menuList}
            setMenuList={setMenuList}
            menuListEnglish={menuListEnglish}
            setMenuListEnglish={setMenuListEnglish}
            textInformation={textInformation}
            setTextInformation={setTextInformation}
            menuFetchUrl={menuFetchUrl}
            setMenuFetchUrl={setMenuFetchUrl}
            menuFetchSelectors={menuFetchSelectors}
            setMenuFetchSelectors={setMenuFetchSelectors}
            menuFetchAvailable={menuFetchAvailable}
            setMenuFetchAvailable={setMenuFetchAvailable}
            menuFetchUrlEnglish={menuFetchUrlEnglish}
            setMenuFetchUrlEnglish={setMenuFetchUrlEnglish}
            config={config}
            setConfig={setConfig}
            setMenuFetchUrlType={setMenuFetchUrlType}
            ignoreTerms={ignoreTerms}
            setIgnoreTerms={setIgnoreTerms}
            includeTerms={includeTerms}
            setIncludeTerms={setIncludeTerms}
            lokasjonstype={lokasjonstype}
            suggestedTagsPanel={suggestedTagsPanel}
          />
        ) : (
          <>
            <label className='editPageLabel'>
              {lokasjonstype === "restaurant"
                ? "Legg til nytt menyobjekt"
                : "Legg til ny aktivitet"}{" "}
              {userInformation?.moderator ? (
                <button
                  onClick={() => {
                    setNewMenuType("demo1");
                  }}>
                  {text[language].opendemo}
                </button>
              ) : (
                <></>
              )}
              {userInformation?.admin && menuFetchUrlType}
            </label>
            <div className='menuPageItemInfoContainer'>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "38%",
                }}>
                <label className='editPageLabel'>Navn</label>
                <input
                  placeholder='Navn'
                  value={newMenuFields.name}
                  onChange={(x) => {
                    setNewMenuFields((prevItems) => ({
                      ...prevItems,
                      name: x.target.value,
                    }));
                  }}
                />
                <label
                  style={{
                    display: missingFields.name ? "block" : "none",
                    color: "#f9615b",
                  }}>
                  Her mangler det noe!
                </label>
              </div>
              {lokasjonstype === "restaurant" ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "38%",
                  }}>
                  <label className='editPageLabel'>Allergener</label>
                  <input
                    placeholder='Allergener'
                    value={newMenuFields.allergies}
                    onChange={(x) => {
                      setNewMenuFields((prevItems) => ({
                        ...prevItems,
                        allergies: x.target.value,
                      }));
                    }}
                  />
                  <label
                    style={{
                      display: missingFields.allergies ? "block" : "none",
                      color: "#f9615b",
                    }}>
                    Her mangler det noe!
                  </label>
                </div>
              ) : (
                <></>
              )}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label className='editPageLabel'>Pris</label>
                <input
                  placeholder='Pris'
                  value={newMenuFields.price}
                  onChange={(x) => {
                    setNewMenuFields((prevItems) => ({
                      ...prevItems,
                      price: x.target.value,
                    }));
                  }}
                />
                <label
                  style={{
                    display: missingFields.price ? "block" : "none",
                    color: "#f9615b",
                  }}>
                  Her mangler det noe!
                </label>
              </div>
            </div>
            <div
              className='menuPageItemInfoContainer'
              style={{ display: "flex", flexDirection: "column" }}>
              <label className='editPageLabel'>
                Skriv en kort beskrivende tekst{" "}
                {lokasjonstype === "restaurant"
                  ? ""
                  : '(linker som starter med "https" og "www" kan inkluderes)'}
              </label>
              <textarea
                placeholder='Skriv en kort beskrivende tekst'
                style={{ height: "100px" }}
                value={newMenuFields.description}
                onChange={(x) => {
                  setNewMenuFields((prevItems) => ({
                    ...prevItems,
                    description: x.target.value,
                  }));
                }}
              />
              <label
                style={{
                  display: missingFields.description ? "block" : "none",
                  color: "#f9615b",
                }}>
                Her mangler det noe!
              </label>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "20px",
                width: "25%",
              }}>
              <label className='editPageLabel'>Kategori</label>
              <select
                style={{ width: "150px" }}
                onChange={(x) => {
                  setSelectedCategory(x.target.value);
                }}>
                <option value=''>Velg kategori</option>
                <option value='newCategory'>Ny kategori</option>
                {Object.keys(menuList).map((element, index) => (
                  <option key={index} value={element}>
                    {element}
                  </option>
                ))}
              </select>

              <label
                style={{
                  display: missingFields.category ? "block" : "none",
                  color: "#f9615b",
                }}>
                Her mangler det noe!
              </label>
              {selectedCategory === "newCategory" ? (
                <>
                  <input
                    placeholder='Ny kategori'
                    style={{ marginTop: "10px" }}
                    value={newMenuFields.newCategory}
                    onChange={(x) => {
                      setNewMenuFields((prevItems) => ({
                        ...prevItems,
                        newCategory: x.target.value,
                      }));
                    }}
                  />
                  <label
                    style={{
                      display: missingFields.newCategory ? "block" : "none",
                      color: "#f9615b",
                    }}>
                    Her mangler det noe!
                  </label>
                </>
              ) : (
                <></>
              )}
            </div>
            <div>
              <button
                onClick={addNewMenuItem}
                className='universalButtonRed'
                style={{
                  width: "150px",
                  marginTop: "25px",
                  marginRight: "10px",
                }}>
                Legg til
              </button>
              <button onClick={onGoBack} className='universalButton'>
                Avbryt
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditMenu;
